import { atom } from 'jotai';

export const profileMenuOpenAtom = atom(false);
